import React from "react";

function ProjectDot(props) {
    return (
        <div className={"project-dot ".concat(props.tagName)}></div>
    );
}

export default ProjectDot;